import { Form, Popover } from "antd";
import CrudOptions from "./crud-options";
import { useTranslation } from "react-i18next";
import LoadMoreSelect from "./LoadMoreSelect";
import { Link } from "react-router-dom";
import PermissionDebugger from "./PermissionDebugger";
import MaskIcon from "./MaskIcon";
import PrimaryButton from "./PrimaryButton";
import SecondaryButton from "./SecondaryButton";
import { InfoCircleOutlined } from "@ant-design/icons";
import { Tooltip } from "antd";
import { useMemo } from "react";

export const SELECT_FIELD_CLASSNAME =
  "w-full h-[62px] [&_.ant-select-clear]:top-1/2 [&_.ant-select-clear]:-translate-y-1/2 [&_.ant-select-clear]:!mt-0 [&_.ant-select-arrow]:top-1/2 [&_.ant-select-arrow]:-translate-y-1/2 [&_.ant-select-arrow]:!mt-0";

export const Label = ({ title, size, required, tooltip }) => {
  return (
    <div
      className={`xl:mb-[10px] mb-2 leading-tight shrink-0 ${size ? size : "text-base"}`}
    >
      {title}
      {required ? (
        <span className="text-danger text-[25px] relative top-1 ms-1">*</span>
      ) : (
        <span className="text-danger text-[25px] relative top-1 ms-1"></span>
      )}
      {tooltip && (
        <Tooltip title={tooltip} placement="top">
          <InfoCircleOutlined className="text-text-subtle cursor-help text-sm flex-shrink-0 mx-1" />
        </Tooltip>
      )}
    </div>
  );
};
export const SubmitButton = ({ children, className = "", ...props }) => {
  return (
    <PrimaryButton
      type="submit"
      className={`w-full h-[62px] mt-2 ${className}`}
      {...props}
    >
      {children}
    </PrimaryButton>
  );
};

export const OptionsButton = ({ profile, actions, ...props }) => {
  const { t } = useTranslation();
  const firstPermissionId = actions?.find((a) => a.permissionId)?.permissionId;

  const buttonContent = profile ? (
    <div className="w-[120px] h-9 py-[9px] bg-surface rounded-md border border-stone-300 justify-center flex items-center cursor-pointer gap-0.5">
      <img alt="" src="/icons/more.svg" className="pt-[2px]" width={21} />
      <p className="text-[15.5px]">{t("options")}</p>
    </div>
  ) : (
    <MaskIcon
      src="/icons/blue-dots.svg"
      alt={t("options")}
      className="h-[25px] w-[27px] cursor-pointer bg-brand-strong"
    />
  );

  const popoverContent = (
    <Popover
      content={<CrudOptions actions={actions} {...props} />}
      trigger="click"
    >
      {buttonContent}
    </Popover>
  );

  return firstPermissionId ? (
    <PermissionDebugger permissionId={firstPermissionId}>
      {popoverContent}
    </PermissionDebugger>
  ) : (
    popoverContent
  );
};
export const OptionsButton2 = ({ actions, ...props }) => {
  const { t } = useTranslation();
  const firstPermissionId = actions?.find((a) => a.permissionId)?.permissionId;

  const popoverContent = (
    <Popover
      content={<CrudOptions actions={actions} {...props} />}
      trigger="click"
    >
      <button className="flex items-center justify-center gap-[9.5px] rounded-md bg-brand h-[44px] px-[31px] font-bold text-[13px] text-surface cursor-pointer">
        <img src="/icons/dots.svg" alt="" />
        {t("options")}
      </button>
    </Popover>
  );

  return firstPermissionId ? (
    <PermissionDebugger permissionId={firstPermissionId}>
      {popoverContent}
    </PermissionDebugger>
  ) : (
    popoverContent
  );
};

export const CustomerSelect = ({
  id = null,
  name = "customer_id",
  required = true,
  seededOptions,
  addButton = null,
}) => {
  const { t } = useTranslation();
  const extraParams = useMemo(
    () => ({ deleted: false, ...(id != null ? { id } : {}) }),
    [id]
  );
  const selectItem = (
    <Form.Item
      rules={
        required
          ? [{ required: true, message: t("formItemRules.requiredMessage") }]
          : []
      }
      name={name}
      className={addButton ? "grow mb-0" : undefined}
    >
      <LoadMoreSelect
        url="dashboard/customers-search"
        extraParams={extraParams}
        seededOptions={seededOptions}
        mapOption={(c) => ({
          label:
            c?.full_name ||
            [c?.fname, c?.lname].filter(Boolean).join(" ").trim() ||
            "",
          value: c.id,
        })}
        placeholder={t("placeholder.select")}
        className={SELECT_FIELD_CLASSNAME}
      />
    </Form.Item>
  );

  if (!addButton) return selectItem;

  return (
    <div className="flex items-start gap-2">
      {selectItem}
      {addButton}
    </div>
  );
};
export const AddBottomButton = ({ url, name }) => {
  return (
    <Link to={url}>
      <PrimaryButton className="w-40 h-11 px-3 py-2 text-xs font-medium font-['Readex_Pro'] leading-none">
        + {name}
      </PrimaryButton>
    </Link>
  );
};

export const ReportsTotoal = ({ total, name }) => {
  return (
    <div className="flex  h-[95px] px-[22px] py-[25px] flex-col justify-between items-start flex-shrink-0 rounded-[7px] bg-[#F8F8F8]">
      <h1 className="text-[rgba(22,_19,_19,_0.80)] font-[Roboto] text-[30px] not-italic font-medium leading-[34px]">
        {total}
      </h1>
      <p className="text-[#161313] text-right text-[14px] not-italic font-medium leading-[14px]">
        {name}
      </p>
    </div>
  );
};

// Export button components
export { PrimaryButton, SecondaryButton };
